import { connect } from 'react-redux';
import { PreviewHeader } from '../../components/PreviewHeader/PreviewHeader';
import { IPreviewHeaderField } from '../../components/PreviewHeader/types';
import { IApplicationState } from '../../../../../../../types/types';
import { IPreviewHeaderHOCProps } from './types';
import { getBoardCardsCount } from '../../../../../../../store/model/selectors/getBoardCardsCount';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IPreviewHeaderHOCProps
): IPreviewHeaderField => {
    return {
        cardsCount: getBoardCardsCount(state, boardId),
    };
};

export const PreviewHeaderHOC = connect(mapStateToProps, null)(PreviewHeader);

PreviewHeaderHOC.displayName = 'PreviewHeaderHOC';
